// extracted by mini-css-extract-plugin
module.exports = {"form":"AddProjectNoteForm_form__3kQNQ","textarea":"AddProjectNoteForm_textarea__MDXBx"};